import ProjectTypeBadge, { PROJECT_TYPE_BY_USED_BY_ITEM_TYPE } from "components/ProjectTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import styles from "./styles.module.css";
import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableTypeCell = ({
  item,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ProjectTypeBadge
        className={styles.typeCell}
        projectType={PROJECT_TYPE_BY_USED_BY_ITEM_TYPE[item.type]}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableTypeCell;
